module.exports = __webpack_public_path__ + "img/succ.bf54bae6.png";